import { Component, Input, Output, OnInit, OnChanges, OnDestroy, SimpleChanges, ViewChild, AfterViewInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { cloneDeep as _cloneDeep, find as _find } from 'lodash';
import { SelectOption } from '../../interfaces/select-option.interface';
import { ValidationMessage } from '../../classes/validation-message';
import { CommonValues } from '../../classes/common-values';
import { MatSelect } from '@angular/material/select';

@Component({
    selector: 'nsc-form-field-select',
    templateUrl: './form-field-select.component.html',
    styleUrls: ['./form-field-select.component.scss'],
    standalone: false
})
export class FormFieldSelectComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
    @ViewChild('selectRef') selectRef: MatSelect;
    @Input() controlName: string;
    @Input() idx: string;
    @Input() group: FormGroup;
    @Input() hint: string;
    @Input() placeholder: string;
    @Input() selectObjects: SelectOption[];
    @Input() loading: boolean = false;
    @Input() required: boolean = true;

    selectedValue: any = {
        value: null,
        name: null,
    };
    content = {
        hint: ''
    };
    panelStatusAnnouncement = '';
    private suppressNextCollapsedAnnouncement = false;
    private isPanelOpen = false;

    constructor( private validationMessage: ValidationMessage,
        private commonValues: CommonValues) { }

    ngOnInit() {
        this.setHint(this.hint, this.required);
        if (this.group.controls[this.controlName].value) {
            const controls = this.group.controls[this.controlName].value;
            const selectObjectsList = _cloneDeep(this.selectObjects);
            const selectedValueTemp = _find(selectObjectsList, function(obj) {
                if (obj.value === controls) {
                    return obj;
                }
            });
            if (typeof selectedValueTemp != this.commonValues.api.undefined && selectedValueTemp != null ){
                this.selectedValue = selectedValueTemp;
            }

        }
    }

    ngOnDestroy() {
        // Clean up keyboard blocking listener
        if (this.selectRef?._elementRef) {
            this.selectRef._elementRef.nativeElement.removeEventListener('keydown', this.handleKeydown, true);
        }
    }

    ngAfterViewInit() {
        // Prevent keyboard navigation and character selection when dropdown is closed
        if (this.selectRef?._elementRef) {
            this.selectRef._elementRef.nativeElement.addEventListener('keydown', this.handleKeydown, true);
        }
    }

    private handleKeydown = (event: KeyboardEvent): void => {
        // When dropdown is closed, prevent all keys except Tab, Enter, Escape, Shift
        // This blocks: arrow keys, character keys, Home, End, PageUp, PageDown, Space
        if (!this.isPanelOpen) {
            const allowedKeys = ['Tab', 'Enter', 'Escape', 'Shift'];
            
            if (!allowedKeys.includes(event.key)) {
                event.preventDefault();
                event.stopImmediatePropagation();
            }
        }
    }

    changeValue(value: any) {
        this.selectedValue.name = value.source.selected.viewValue;
        this.selectedValue.id = value.source.selected.value;
        this.suppressNextCollapsedAnnouncement = true;
        this.panelStatusAnnouncement = '';
        const message = `${this.selectedValue.name} selected`;
        Promise.resolve().then(() => {
            this.panelStatusAnnouncement = message;
        });
    }

    onPanelOpenedChange(isOpen: boolean, select: MatSelect): void {
        this.isPanelOpen = isOpen;
        
        if (isOpen) {
            const expandedMessage = `${this.placeholder} combo box expanded${this.required ? ' required' : ''} opens list`;
            this.panelStatusAnnouncement = '';
            Promise.resolve().then(() => {
                this.panelStatusAnnouncement = expandedMessage;
                const panelEl = select.panel?.nativeElement;
                if (panelEl) {
                    panelEl.removeAttribute('aria-labelledby');
                    panelEl.setAttribute('aria-label', '');
                }
            });
            return;
        }
        if (this.suppressNextCollapsedAnnouncement) {
            this.suppressNextCollapsedAnnouncement = false;
            return;
        }
        this.panelStatusAnnouncement = '';
        Promise.resolve().then(() => {
            this.panelStatusAnnouncement = 'Combobox Collapsed';
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        const newHint = changes.hint ? changes.hint.currentValue : this.hint;
        const newRequired = changes.required ? changes.required.currentValue : this.required;
    
        this.setHint(newHint, newRequired);
      }

    setHint(hint: string, required: boolean): void {
        // if a field isn't required and it's optional, we need to combine the `hint` values;
        this.content.hint = `${hint || ''} ${required ? '' : '(Optional)'}`;
      }
}
